import React from 'react';
import { CurrencyAttributes } from '@loyalty/shared-common/gamification-api-client';
import { useTranslation } from 'react-i18next';

export function CurrencyName({ currency }: { currency: CurrencyAttributes }) {
  const { i18n } = useTranslation();
  const translation =
    currency.i18nAttributes[i18n.language] || Object.values(currency.i18nAttributes).pop();
  return <>{translation.name}</>;
}
